import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import PricingComponent from "../components/Pricing/Pricing";

const Pricing = () => {
    return (
        <>
            <Navbar />
            <PricingComponent />
            <Footer />
        </>
    )
}

export default Pricing;
